<template>
  <w-sliding-popup ref="slidingPopup" title="연관 KEDB 추가" width="950px" @close="closePopup">
    <div slot="content">
      <w-kedb-table ref="kedbTable" :viewType="viewType" :filter-tag="filterTag" @click-kedb-detail-view="clickKedbDetailView" @selection-row-change="selectionRowChange"></w-kedb-table>
      <w-kedb-detail-popup ref="detailPopup" :viewType="kedbDetailInfoType" :params="dateilPopupInfo" />
    </div>
    <div slot="footer">
      <el-button size="large" :disabled="isAbleSave" @click="saveRelationKedb" type="solid">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { cloneDeep } from 'lodash';
import WKedbTable from '@/views/event/kedb/components/KedbTable';
import WKedbDetailPopup from '@/views/event/kedb/components/popup/KedbDetailPopup';

export default {
  name: 'WRelationKedbAddPopup',
  components: {
    WKedbTable,
    WKedbDetailPopup,
  },
  data() {
    return {
      viewType: '',
      isAbleSave: true,
      dateilPopupInfo: null,
      kedbDetailInfoType: null,
      selectionKedbRow: [],
      filterTag: {},
    };
  },
  methods: {
    open() {
      this.viewType = 'relationKedbPopup';
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업 종료 후 데이터를 초기화한다.
     * @author yelim
     */
    closePopup() {
      this.$refs.kedbTable.$refs.searchField.clear();
      this.$refs.kedbTable.searchType = 'total';
      this.$refs.kedbTable.selectRelationRsc = null;
      this.viewType = null;
    },
    /**
     * 연관 KEDB 추가 팝업을 종료한다.
     * @author yelim
     */
    close() {
      this.closePopup();
      this.$refs.slidingPopup.visible = false;
    },
    clickKedbDetailView(detailInfo) {
      this.kedbDetailInfoType = 'relationKedbPopup';
      this.dateilPopupInfo = cloneDeep(detailInfo);
      this.$refs.detailPopup.open();
    },
    /**
     * KEDB 테이블에서 선택된 항목이 있는 경우 저장버튼을 활성화 한다.
     * @author yelim
     */
    selectionRowChange(row) {
      this.selectionKedbRow = cloneDeep(row);
      this.isAbleSave = !(row.length > 0);
    },
    /**
     * kedb 테이블에서 선택한 항목을 연관 KEDB 추가를 수행한 뷰에서 저장하도록 이벤트를 트리거
     * @author yelim
     */
    saveRelationKedb() {
      this.$emit('save-relation-kedb-info', cloneDeep(this.selectionKedbRow));
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/components/popup/RelationKedbAddPopup.vue